module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-256x256-0d875d23effdf610967291edd500901c.png";